
import { defineComponent, reactive, onMounted, toRefs } from "vue";
import { useRouter } from "vue-router";
import { config } from "@/Config";

export default defineComponent({
  name: "TagsCard",
  components: {
    // ErrorList, // googleAuth
    // facebookLogin
  },
  props: {
    activity: Object,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const state = reactive({
      data: {
        imageBaseUrl: "",
      },
      ui: {
        postLoading: {
          processRegistration: false,
        },
      },
    });
    function selectedTag(item: object) {
      emit("selectedRecentTag", item);
    }
    function redirectToChannel(form: any) {
      if(!form.channel.uuid) return false
      router.push({
        name: "admin-channel",
        params: { channelId: form.channel.uuid},
      });
      // $(".modal-backdrop").remove();
    }
    onMounted(() => {
      state.data.imageBaseUrl = config.imageBaseUrl;
    });
    return {
      redirectToChannel,
      selectedTag,
      ...toRefs(state),
    };
  },
});
